import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  font-size: 1.2rem;
  line-height: 175%;
  page-break-inside: avoid;
  white-space: pre-wrap;
  padding: 0 1.5rem;
  margin-bottom: 2rem;
`

@observer
export default class Notes extends Component {
  render() {
    const { children } = this.props

    return (
      <Box>
        {children}
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/Notes.js